module.exports = __webpack_public_path__ + "media/Whats wrong with you.d475379a.mp3";